import Marionette from 'backbone.marionette';
import {
	AdvertisingView,
	Gamebar,
	TippingGlobalNotification,
	TippingTipsLayout,
	TipsCollection,
	UserInfoRow,
	WidgetBets,
	WidgetLadder
} from '../../views';
import { Tipping as GameBarModel } from '../../models';
import { Model } from 'backbone';

import { 
	FinMatches, 
	Ladder, 
	Rounds, 
	SooMatches, 
	Squads, 
	Tipping, 
	Venues, 
} from '../../collections';

import { CompShareModel, User } from '../../models';

import { isMobileView } from '../../../../core/utils';

export default class TippingController extends Marionette.Object {
	/**
	 * Tipping page route handler
	 */
	tipping() {
		const
			pageLayout = new TippingTipsLayout({
				rounds: new Rounds(),
				squads: new Squads(),
				venues: new Venues(),
				collection: new Tipping(),
				soo_matches: new SooMatches(),
				fin_matches: new FinMatches(),
			}),
			advertisingFooter = new AdvertisingView( {
				ad_id:   'div-gpt-ad-1613627585311-0',
				ad_path: 'tip-footer',
				size:    [[970, 250], [320, 50], [728, 90], [300, 250]],
				pos: 3,
			} );

		pageLayout.getRegion('gamebar').show(new Gamebar());

		pageLayout.getRegion('user_info').show(new UserInfoRow({
			share: new CompShareModel({
				team_share: true
			}),
			model: new GameBarModel()
		}));

		pageLayout.getRegion('content').show(new TipsCollection());

		if( isMobileView() && User.is_adult ) {
			pageLayout.getRegion('widget_1').show(new WidgetBets());
		}
		else {
			pageLayout.getRegion('widget_1').show(new AdvertisingView( {
				ad_id:   'tip-entry-ad-slot-3',
				ad_path: 'tip-entry',
				size:    [ 300, 250 ],
				pos: 2,
			} ));
		}

		if( isMobileView() ) {
			pageLayout.getRegion('widget_2').show(new AdvertisingView( {
				ad_id:   'div-gpt-ad-1613627585311-0',
				ad_path: 'tip-footer',
				size:    [[970, 250], [320, 50], [728, 90], [300, 250]],
				pos: 2,
			} ));
		}
		else {
			this.getOption('rootView').getRegion('top_ads_container').show(advertisingFooter);
		}

		pageLayout.getRegion('widget_3').show(new WidgetLadder({
			model: new Model(),
			collection: new Ladder()
		}));

		this.getOption('rootView').getRegion('global_notification')
			.show(new TippingGlobalNotification());
		// const root_view = this.getOption('rootView');
		// root_view.getRegion('global_notification').show(new GlobalNotification());
		this.getOption('rootView').getRegion('main').show(pageLayout);
	}
}